import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'sis-info-modal',
  styleUrls: ['./info-modal.component.scss'],
  templateUrl: './info-modal.component.html',
  standalone: false,
})
export class InfoModalComponent {
  private static readonly urlPattern = /(https?:\/\/|www\.)[^\s<]+/gi;

  @Input() title: string;
  @Input() text: string;

  linkedText: string;

  constructor(private modalCtrl: ModalController) {}

  ngOnInit(): void {
    this.linkedText = this.linkify(this.text);
  }

  close() {
    this.modalCtrl.dismiss();
  }

  private linkify(text: string): string {
    if (!text) {
      return '';
    }

    const escaped = this.escapeHtml(text);
    return escaped.replace(InfoModalComponent.urlPattern, (match) => {
      const href = match.startsWith('www.') ? `https://${match}` : match;
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
    });
  }

  private escapeHtml(text: string): string {
    return text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }
}
